import { EUROPEAN_BRANDS_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { useMemo } from "react";

export const useLayoutElementsQueryKey = () => {
  const categoryModel = useCurrentCategoryModel();

  const isEuropeanBrandsCategory =
    categoryModel.urlId.id === EUROPEAN_BRANDS_URL_ID;
  const pathIdentifier =
    categoryModel.mostSpecificPathIdentifier ?? categoryModel.mostSpecificName;

  return useMemo(
    () => [
      "CategoryPageLayoutElements",
      pathIdentifier,

      isEuropeanBrandsCategory,
    ],
    [isEuropeanBrandsCategory, pathIdentifier]
  );
};
